  $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    $('.add-product-title').click(function(){
      if($(this).hasClass('openadd-producttitle')){
        $(this).removeClass('openadd-producttitle');
        $(this).next().removeClass('open-addon-product-blocks');
      }
      else{
        $(this).addClass('openadd-producttitle');
        $(this).next().addClass('open-addon-product-blocks');
      }
    })

  });

// $(document).ready(function() {
//   function startAnimation() {
//     $(".animationimage, .animationtext").hide(); // Hide all images and text initially
//     $(".animationimage-1, .animationimage-5").show(); // Show first and last images by default

//     // Step 1: Slide down each image sequentially for a smoother effect
//         $(".animationimage-2, .animationimage-3, .animationimage-4").slideDown(1000, function() {
//           // Step 2: After all images are visible, slide down texts sequentially
//           $(".animationtext-1").fadeIn(1000, function() {
//             $(".animationtext-2").fadeIn(1000, function() {
//               $(".animationtext-3").fadeIn(1000, function() {
//                 $(".animationtext-4").fadeIn(1000, function() {
//                     // Step 3: Slide up texts and images in reverse order with smooth scrolling back to top
//                     // $(".animationtext").delay(1000).fadeOut(500, function(){
//                     //   $(".animationimage-2, .animationimage-3, .animationimage-4").delay(1500).slideUp(1000);  
//                     // });
//                 });
//               });
//             });
//           });
//         });
//   // Start the animation loop immediately
//   }
//   startAnimation();

//   // Run the animation loop every 60 seconds
//   // setInterval(startAnimation, 40000);
// });

$(document).ready(function () {
  function startAnimation() {
    $(".animationimage, .animationtext").hide(); // Hide all images and text initially
    // $(".animationimage-1, .animationimage-5").show(); // Show first and last images by default

    // Step 1: Slide down each image sequentially for a smoother effect
    $(".animationimage-2, .animationimage-3, .animationimage-4").slideDown(1000, function () {
      // Step 2: After all images are visible, slide down texts sequentially
      $(".animationtext-1").fadeIn(1000, function () {
        $(".animationtext-2").fadeIn(1000, function () {
          $(".animationtext-3").fadeIn(1000, function () {
            $(".animationtext-4").fadeIn(1000, function () {
              // Animation ends
            });
          });
        });
      });
    });
  }

  // Helper function to check if an element is in the viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  }

  // Attach scroll event listener
  $(window).on("scroll", function () {
    const animationSection = $(".icon-with-text-pdp-section"); // Replace with your animation section's class or ID
    if (animationSection.length && isElementInViewport(animationSection[0])) {
      // Trigger the animation when the section is visible in the viewport
      if (!animationSection.data("animated")) {
        animationSection.data("animated", true); // Prevent multiple triggers
        startAnimation();
      }
    }
  });
});


// bundle product add on js start
document.addEventListener('DOMContentLoaded', function() {
function updateTotalPriceForAddon($addonQuantityInput) {
  // Get the main product price once
  var mainProductPrice = parseFloat($('.price__regular .price-item--regular').data('price'));
  var mainProductcomparePrice = parseFloat($('.price__sale .price-compare').data('compare-price'));
  var mainProductsalePrice = parseFloat($('.price__sale .price-item--sale').data('sale-price'));

  // Get the add-on price and quantity from the clicked add-on's input
  var pricePerUnit = $addonQuantityInput.data('price');
  var quantity = parseInt($addonQuantityInput.val()) || 0;
  var addonTotalPrice = pricePerUnit * 1;

  // Calculate the new total price (main product price + specific add-on total)
  var newTotalPrice = mainProductPrice + addonTotalPrice;
  var newTotalcomparePrice = mainProductcomparePrice + addonTotalPrice;
  var newTotalsalePrice = mainProductsalePrice + addonTotalPrice;

  console.log('Main Product Price:', mainProductPrice);
  console.log('Add-On Total Price for this item:', addonTotalPrice);
  console.log('New Total Product Price:', newTotalPrice);
  console.log('New Total compare product Price:', newTotalcomparePrice);
  console.log('New Total total Product Price:', newTotalsalePrice);

  // Format the total price with the ILS currency
  
  var formattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalPrice);
  var compareformattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalcomparePrice);
  var saleformattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalsalePrice);
  console.log(formattedTotal);
  $('.price__regular .price-item--regular').data('price',newTotalPrice);
  $('.price__sale .price-compare').data('compare-price',newTotalcomparePrice);
  $('.price__sale .price-item--sale').data('sale-price',newTotalsalePrice);
  $('.price__regular').find('.priceRange').text(formattedTotal);
  $('.price__sale .price-compare').find('.priceRange').text(compareformattedTotal);
  $('.price__sale .price-item--sale').find('.priceRange').text(saleformattedTotal);
}

function updateTotalPriceForminus($addonQuantityInput) {
  // Get the main product price once
  var mainProductPrice = parseFloat($('.price__regular .price-item--regular').data('price'));
  var mainProductcomparePrice = parseFloat($('.price__sale .price-compare').data('compare-price'));
  var mainProductsalePrice = parseFloat($('.price__sale .price-item--sale').data('sale-price'));
  
  // Get the add-on price and quantity from the clicked add-on's input
  var pricePerUnit = $addonQuantityInput.data('price');
  var quantity = parseInt($addonQuantityInput.val()) || 0;
  var addonTotalPrice = pricePerUnit * 1;

  // Calculate the new total price (main product price + specific add-on total)
  var newTotalPrice = mainProductPrice - addonTotalPrice;
  var newTotalcomparePrice = mainProductcomparePrice - addonTotalPrice;
  var newTotalsalePrice = mainProductsalePrice - addonTotalPrice;

  console.log('Main Product Price:', mainProductPrice);
  console.log('Add-On Total Price for this item:', addonTotalPrice);
  console.log('New Total Product Price:', newTotalPrice);
   console.log('New Total compare product Price:', newTotalcomparePrice);
  console.log('New Total total Product Price:', newTotalsalePrice);

  // Format the total price with the ILS currency
  
  var formattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalPrice);
  var compareformattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalcomparePrice);
  var saleformattedTotal = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(newTotalsalePrice); 
  $('.price__regular .price-item--regular').data('price',newTotalPrice);
  $('.price__sale .price-compare').data('compare-price',newTotalcomparePrice);
  $('.price__sale .price-item--sale').data('sale-price',newTotalsalePrice);
  $('.price__regular').find('.priceRange').text(formattedTotal);
  $('.price__sale .price-compare').find('.priceRange').text(compareformattedTotal);
  $('.price__sale .price-item--sale').find('.priceRange').text(saleformattedTotal);
}  

// Handle click on each `.addon-quantity-minus` button
$('.addon-quantity-minus').on('click', function(event) {
  event.preventDefault();

  // Find the associated .addon-quantity input and decrease its value
  var $quantityInput = $(this).siblings('.addon-quantity');

  console.log($quantityInput.val(),$quantityInput.val() >= 0 );
  // Update the total price only for this specific add-on
  updateTotalPriceForminus($quantityInput);
  if($quantityInput.val() == 0){
    $(this).prop('disabled', true);
  }
});

// Handle click on each `.addon-quantity-plus` button
$('.addon-quantity-plus').on('click', function(event) {
  event.preventDefault();

  // Find the associated .addon-quantity input and increase its value
  var $quantityInput = $(this).siblings('.addon-quantity');
  // Update the total price only for this specific add-on
  console.log($quantityInput.val(),$quantityInput.val() >= 0 );
  updateTotalPriceForAddon($quantityInput);
  if($quantityInput.val() > 0){
     $(this).siblings('.addon-quantity-minus').prop('disabled', false); 
  }
  
});

  
  // var mainAddToCartButton = document.querySelector('.product-form__submit');

//   if (mainAddToCartButton) {
//   mainAddToCartButton.addEventListener('click', function(event) {
//     event.preventDefault();

//     // Array to store add-on products to add to cart
//     var addonProducts = [];

//     // Collect add-on product data
//     document.querySelectorAll('.addon-quantity').forEach(input => {
//       var quantity = parseInt(input.value);
//       if (quantity > 0) {
//         addonProducts.push({
//           id: input.getAttribute('data-variant-id'),
//           quantity: quantity
//         });
//       }
//     });

//     console.log(addonProducts); // Log the collected add-on products

//     if (addonProducts.length > 0) {
//       // Create a payload with all add-on items in one request
//       var payload = {
//         items: addonProducts
//       };

//       // Perform the add-to-cart request for all add-ons in one request
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify(payload)
//       })
//       .then(response => {
//         if (!response.ok) {
//           throw new Error(`Failed to add add-on products: ${response.statusText}`);
//         }
//         return response.json();
//       })
//       .then(data => {
//         console.log('Add-on products added:', data);
//         // Submit the main product form after add-ons are added
//         document.querySelector('form.product-form-custom').submit();
//       })
//       .catch(error => {
//         console.error('Error adding add-on products:', error);
//       });
//     } else {
//       // No add-on products; submit the main product form directly
//       document.querySelector('form.product-form-custom').submit();
//     }
//   });
// }
  
var mainAddToCartButton = document.querySelector('.product-form__submit');
if (mainAddToCartButton) {
  mainAddToCartButton.addEventListener('click', function (event) {
    event.preventDefault();

    // Array to store add-on products to add to cart
    var addonProducts = [];

    // Collect add-on product data
    document.querySelectorAll('.addon-quantity').forEach(input => {
      var quantity = parseInt(input.value);
      if (quantity > 0) {
        addonProducts.push({
          id: input.getAttribute('data-variant-id'),
          quantity: quantity
        });
      }
    });

    // Add add-on products to cart
    if (addonProducts.length > 0) {
      var payload = {
        items: addonProducts
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to add add-on products: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          console.log('Add-on products added:', data);

          // Add the main product to the cart
          addMainProductToCart();
        })
        .catch(error => {
          console.error('Error adding add-on products:', error);
        });
    } else {
      // Add the main product directly if no add-ons
      addMainProductToCart();
    }

    // Function to add the main product to the cart
    function addMainProductToCart() {
      const mainProductForm = document.querySelector('form.product-form-custom');
      const formData = new FormData(mainProductForm);

      // Add sections rendering data
      formData.append(
        'sections',
        ['cart-notification', 'cart-icon-bubble'] // Replace with your actual section IDs
      );
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to add main product: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          console.log('Main product added:', data);

          // Render the product in the cart notification
          updateCartNotificationProduct(data);

          // Open the mini cart
          openMiniCart();

          // Update cart count
          updateCartCount();
        })
        .catch(error => {
          console.error('Error adding main product:', error);
        });
    }

    // // Function to update the cart notification product div
    // function formatMoney(amount, format = "₪ {{amount}}") {
    //   const cents = (amount / 100); // Convert cents to dollars
    //   return format.replace("{{amount}}", cents);
    // }

    
function updateCartNotificationProduct(product) {
  const cartNotificationProduct = document.querySelector('#cart-notification-product');

  if (cartNotificationProduct) {
    // Clear previous contents
    cartNotificationProduct.innerHTML = '';
    // Assume product.price contains the price in cents (e.g., 1500 for $15.00)
    
    // Create the HTML structure for cart item using Liquid code format
    const productHTML = `
      <div id="cart-notification-product-${product.key}" class="cart-item">
        ${product.image ? `
          <div class="cart-notification-product__image global-media-settings">
            <img src="${product.image}" alt="${product.image.alt}" width="70" height="${70 / product.image.aspect_ratio}" loading="lazy">
          </div>
        ` : ''}
        <div>
          <h3 class="cart-notification-product__name h4">${product.title}</h3>
          <dl>
            ${Array.isArray(product.properties) ? product.properties.map(property => `
              <div class="product-option">
                <dt>${property.first}:</dt>
                <dd>${property.last}</dd>
              </div>
            `).join('') : ''}
          </dl>
        </div>
      </div>
    `;

    // Append the product HTML
    cartNotificationProduct.innerHTML = productHTML;
  }
}


    // Function to open mini cart
    function openMiniCart() {
      const miniCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (miniCart) {
        miniCart.classList.add('is-open');
        if (miniCart.tagName.toLowerCase() === 'cart-notification') {
          miniCart.open();
        }
      } else {
        console.warn('Mini cart not found. Make sure cart-notification or cart-drawer exists.');
      }
    }

    // Function to update the cart count
    function updateCartCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCount = cart.item_count;
          const cartCountElement = document.querySelector('.cart-count-bubble span');
          if (cartCountElement) {
            cartCountElement.textContent = cartCount;
            $('.cart-count-bubble').removeClass('custom-cart-empty');
          }
        })
        .catch(error => {
          console.error('Error fetching cart state:', error);
        });
    }
  });
}


});

